import { createRouter, createWebHistory } from 'vue-router'
import { setPageTitle } from '@/utils/title'

// 路由懒加载组件，添加webpackChunkName注释进行代码分割
const HomePage = () => import(/* webpackChunkName: "home" */ '../pages/home/index.vue')
const CenterPage = () => import(/* webpackChunkName: "center" */ '../pages/center/index.vue')
const JoinPage = () => import(/* webpackChunkName: "join" */ '../pages/join/index.vue')
const GoodPage = () => import(/* webpackChunkName: "good" */ '../pages/good/index.vue')
const ToolPage = () => import(/* webpackChunkName: "tool" */ '../pages/tool/index.vue')
const LoginPage = () => import(/* webpackChunkName: "login" */ '../pages/login/index.vue')
const LoginCallbackPage = () => import(/* webpackChunkName: "login" */ '../pages/login/auth_callback.vue')
const RecordsPage = () => import(/* webpackChunkName: "records" */ '../pages/center/records/index.vue')

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '青象传媒'
    },
    component: LoginPage
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: '青象传媒',
      requiresAuth: true
    },
    component: HomePage
  },
  {
    path: '/center',
    name: 'Center',
    meta: {
      title: '个人中心',
      requiresAuth: true
    },
    component: CenterPage,
  },
  {
    path: '/join',
    name: 'Join',
    meta: {
      title: '加入我们',
      requiresAuth: true
    },
    component: JoinPage
  },
  {
    path: '/good',
    name: 'Good',
    meta: {
      title: '优选资源',
      requiresAuth: true
    },
    component: GoodPage
  },
  {
    path: '/tool',
    name: 'Tool',
    meta: {
      title: '小工具',
      requiresAuth: true
    },
    component: ToolPage
  },
  {
    path: '/auth_callback',
    name: 'AuthCallback',
    meta: {
      title: '登录回调',
      requiresAuth: false
    },
    component: LoginCallbackPage
  },
  {
    path: '/center/records',
    name: 'Records',
    meta: {
      title: '提现记录',
      requiresAuth: true
    },
    component: RecordsPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 添加路由懒加载的错误处理
router.onError((error) => {
  console.error('路由加载失败:', error)
  // 可以在这里添加全局错误处理逻辑
})

// 检查用户是否已登录
function isAuthenticated() {
  return !!localStorage.getItem('token')
}

// 路由守卫：检查登录状态和设置页面标题
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    setPageTitle(to.meta.title)
  } else {
    setPageTitle('青象传媒')
  }

  // 检查是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要认证的路由，检查token
    if (!isAuthenticated()) {
      // 没有token，跳转到登录页面
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 保存要访问的页面路径
      })
      return
    }
  }

  // 如果访问登录页面但已登录，跳转到首页
  if (to.path === '/login' && isAuthenticated()) {
    console.log('用户已登录，跳转到首页')
    next('/home')
    return
  }

  next()
})

export default router
